// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.partcatelogue_containers {
  overflow: hidden;
  height: 100vh;
}
.partcatelogue_containers .partcatelogue_container {
  width: 100%;
  display: flex;
  overflow: hidden;
}
.partcatelogue_containers .partcateloguemain {
  width: 100%;
  background: #ffffff;
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 66px);
  scrollbar-width: none;
}
.partcatelogue_containers .partcateloguemain::-webkit-scrollbar {
  width: 0px;
}
.partcatelogue_containers .partcateloguemain::-webkit-scrollbar-thumb {
  background: transparent;
}
.partcatelogue_containers .part-img-cateloguues {
  width: 4.4rem;
  height: 4.4rem;
}
.partcatelogue_containers .tvsparts_text {
  font-family: "Nunito";
  font-size: 0.75rem;
  font-weight: 500;
  display: flex;
  padding: 0rem 1rem;
  align-items: center;
}
.partcatelogue_containers .partcateloguebuttons_container {
  display: flex;
  justify-content: space-between;
  width: 96%;
  margin: 1rem auto;
}
.partcatelogue_containers .partcateloguebutton {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
}
.partcatelogue_containers .part_catelogue_buttons {
  background: #e4ecf7;
  border-radius: 5px;
  font-family: Nunito;
  font-size: 1rem;
  font-weight: 600;
  padding: 0.4rem 1rem;
}
.partcatelogue_containers .part_catelogue_addbuttons {
  border-radius: 5px;
  font-family: Nunito;
  font-size: 14px;
  font-weight: 600;
  padding: 0.4rem 1rem;
  background: linear-gradient(277.62deg, #0C3688 10%, #2057C2 84.88%);
  color: #ffffff;
  height: 40px;
}
.partcatelogue_containers .tabledata {
  display: flex;
  width: 96%;
  margin: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-x: scroll;
}
.partcatelogue_containers .table {
  border-collapse: collapse;
  width: 100%;
  background: #ffffff;
  border: 0.5px solid #999797;
  overflow: hidden;
  text-overflow: ellipsis;
}
.partcatelogue_containers .tablesth {
  color: white;
  text-align: left;
  padding: 14px 12px;
  background-color: #f5f5f5;
  font-style: normal;
  font-weight: 700;
  font-size: 1rem;
  background: #0c3688;
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 5px -2px 0px 0px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 1rem;
  color: #ffffff;
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
}
.partcatelogue_containers .tabletd {
  text-align: left;
  padding: 22px 5px;
  font-style: normal;
  font-weight: 400;
  font-size: 16.4px;
  text-align: left;
  padding: 14px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #070707;
  border-top: 0.5px solid #999797;
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
}
.partcatelogue_containers .tabletd_file {
  white-space: wrap;
  width: 20rem !important;
}
.partcatelogue_containers .tabletdpartcatelogue {
  text-align: left;
  padding: 22px 5px;
  font-style: normal;
  font-weight: 400;
  font-size: 16.4px;
  text-align: left;
  padding: 14px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #070707;
  border-top: 0.5px solid #999797;
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  width: 30% !important;
}
.partcatelogue_containers .tabletd_view {
  text-align: left;
  padding: 22px 5px;
  text-align: left;
  padding: 14px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  text-decoration-line: underline;
  color: #0c3688;
  border-top: 0.5px solid #999797;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
}
.partcatelogue_containers .footer_div {
  margin-top: 1rem;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
}
.partcatelogue_containers .header_border {
  background: #c0c8da;
  height: 2.4rem;
  border: 1px solid #c0c8da;
}
.partcatelogue_containers .header_border > img {
  margin: 0.9rem 1rem;
}
.partcatelogue_containers .header_border > span {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 1rem;
  display: flex;
  align-items: center;
  letter-spacing: -0.28px;
  margin: 0.7rem 1rem;
}

@media screen and (max-width: 480px) {
  .partcatelogue_container {
    display: flex;
    flex-direction: column;
  }
  .partcatelogue_containers .partcateloguemain {
    width: 100%;
  }
  .partcateloguebuttons_container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  .tabledata {
    overflow-x: scroll !important;
  }
}
@media screen and (max-width: 768px) {
  .partcatelogue_container {
    flex-direction: column;
  }
  .partcateloguemain {
    width: 100% !important;
  }
}
@media screen and (max-width: 544px) {
  .partcateloguebuttons_container {
    flex-wrap: wrap;
  }
}
@media screen and (max-width: 1100px) and (min-width: 769px) {
  .partcateloguebuttons_container {
    flex-wrap: wrap;
    gap: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/PartCatelogue/partcatelogue.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;AACF;AAAE;EACE,WAAA;EACA,aAAA;EACA,gBAAA;AAEJ;AACE;EACE,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;EAUA,qBAAA;AARJ;AAAI;EACE,UAAA;AAEN;AACI;EACE,uBAAA;AACN;AAIE;EACE,aAAA;EACA,cAAA;AAFJ;AAIE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;AAFJ;AAKE;EACE,aAAA;EACA,8BAAA;EACA,UAAA;EACA,iBAAA;AAHJ;AAME;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAJJ;AAME;EACE,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AAJJ;AAME;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mEAAA;EACA,cAAA;EACA,YAAA;AAJJ;AAOE;EACE,aAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACF,uBAAA;EACA,kBAAA;AALF;AAOE;EACE,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;EACF,uBAAA;AALF;AAOE;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,8CAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACF,qBAAA;EACA,uBAAA;AALF;AAOE;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,+BAAA;EACA,gBAAA;EACA,qBAAA;EACA,uBAAA;AALJ;AAQE;EACC,iBAAA;EACA,uBAAA;AANH;AAQE;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,+BAAA;EACF,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;AANF;AASE;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;EACF,uBAAA;AAPF;AASE;EACE,gBAAA;EACA,eAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;AAPJ;AASE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAPJ;AASE;EACE,mBAAA;AAPJ;AASE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAPJ;;AAWA;EACE;IACE,aAAA;IACA,sBAAA;EARF;EAWA;IACE,WAAA;EATF;EAWA;IACE,aAAA;IACA,sBAAA;IACA,SAAA;EATF;EAWA;IACE,6BAAA;EATF;AACF;AAaA;EACE;IACE,sBAAA;EAXF;EAaA;IACE,sBAAA;EAXF;AACF;AAaA;EACE;IACE,eAAA;EAXF;AACF;AAaA;EACC;IACC,eAAA;IACA,SAAA;EAXA;AACF","sourcesContent":[".partcatelogue_containers {\n  overflow: hidden;\n  height: 100vh;\n  .partcatelogue_container {\n    width: 100%;\n    display: flex;\n    overflow: hidden;\n  }\n\n  .partcateloguemain {\n    width: 100%;\n    background: #ffffff;\n    overflow-y: auto;\n    overflow-x: hidden;\n    height: calc(100vh - 66px);\n\n    &::-webkit-scrollbar {\n      width: 0px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: transparent;\n    }\n\n    scrollbar-width: none;\n  }\n  .part-img-cateloguues{\n    width: 4.4rem;\n    height: 4.4rem;\n  }\n  .tvsparts_text {\n    font-family: \"Nunito\";\n    font-size: 0.75rem;\n    font-weight: 500;\n    display: flex;\n    padding: 0rem 1rem;\n    align-items: center;\n  }\n\n  .partcateloguebuttons_container {\n    display: flex;\n    justify-content: space-between;\n    width: 96%;\n    margin: 1rem auto;\n  }\n\n  .partcateloguebutton {\n    display: flex;\n    justify-content: space-between;\n    gap: 1rem;\n  }\n  .part_catelogue_buttons {\n    background: #e4ecf7;\n    border-radius: 5px;\n    font-family: Nunito;\n    font-size: 1rem;\n    font-weight: 600;\n    padding: 0.4rem 1rem;\n  }\n  .part_catelogue_addbuttons{\n    border-radius: 5px;\n    font-family: Nunito;\n    font-size: 14px;\n    font-weight: 600;\n    padding: 0.4rem 1rem;\n    background: linear-gradient(277.62deg, #0C3688 10%, #2057C2 84.88%);\n    color: #ffffff;\n    height: 40px;\n\n  }\n  .tabledata {\n    display: flex;\n    width: 96%;\n    margin: 1rem;\n    overflow: hidden;\n  text-overflow: ellipsis;\n  overflow-x: scroll;\n  }\n  .table {\n    border-collapse: collapse;\n    width: 100%;\n    background: #ffffff;\n    border: 0.5px solid #999797;\n    overflow: hidden;\n  text-overflow: ellipsis;\n  }\n  .tablesth {\n    color: white;\n    text-align: left;\n    padding: 14px 12px;\n    background-color: #f5f5f5;\n    font-style: normal;\n    font-weight: 700;\n    font-size: 1rem;\n    background: #0c3688;\n    box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n    border-radius: 5px -2px 0px 0px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 1rem;\n    color: #ffffff;\n    overflow: hidden;\n  word-break: break-all;\n  text-overflow: ellipsis;\n  }\n  .tabletd {\n    text-align: left;\n    padding: 22px 5px;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16.4px;\n    text-align: left;\n    padding: 14px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    color: #070707;\n    border-top: 0.5px solid #999797;\n    overflow: hidden;\n    word-break: break-all;\n    text-overflow: ellipsis;\n    // width: 26%;\n  }\n  .tabletd_file{\n   white-space: wrap;\n   width: 20rem !important;\n  }\n  .tabletdpartcatelogue{\n    text-align: left;\n    padding: 22px 5px;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16.4px;\n    text-align: left;\n    padding: 14px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    color: #070707;\n    border-top: 0.5px solid #999797;\n  overflow: hidden;\n  word-break: break-all;\n  text-overflow: ellipsis;\n  width: 30% !important;\n\n  }\n  .tabletd_view {\n    text-align: left;\n    padding: 22px 5px;\n    text-align: left;\n    padding: 14px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 14px;\n    text-decoration-line: underline;\n    color: #0c3688;\n    border-top: 0.5px solid #999797;\n    cursor: pointer;\n    overflow: hidden;\n  text-overflow: ellipsis;\n  }\n  .footer_div {\n    margin-top: 1rem;\n    position: fixed;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n  }\n  .header_border {\n    background: #c0c8da;\n    height: 2.4rem;\n    border: 1px solid #c0c8da;\n  }\n  .header_border > img {\n    margin: 0.9rem 1rem;\n  }\n  .header_border > span {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 1rem;\n    display: flex;\n    align-items: center;\n    letter-spacing: -0.28px;\n    margin: 0.7rem 1rem;\n  }\n}\n\n@media screen and (max-width:480px) {\n  .partcatelogue_container{\n    display: flex;\n    flex-direction: column;\n  }\n\n  .partcatelogue_containers .partcateloguemain{\n    width: 100%;\n  }\n  .partcateloguebuttons_container{\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n  }\n  .tabledata{\n    overflow-x: scroll !important ;\n  }\n  \n}\n\n@media screen and (max-width:768px) {\n  .partcatelogue_container{\n    flex-direction: column;\n  }\n  .partcateloguemain{\n    width: 100% !important;\n  }\n}\n@media screen and (max-width:544px) {\n  .partcateloguebuttons_container{\n    flex-wrap: wrap;\n  }\n}\n@media screen and (max-width:1100px) and (min-width:769px) {\n .partcateloguebuttons_container{\n  flex-wrap: wrap;\n  gap: 1rem;\n }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
